import * as React from 'react';

import { get } from 'lodash';
import PropTypes from 'prop-types';

import ActionCell from 'bundles/internal-ui/components/table/ActionCell';
import TableCell from 'bundles/internal-ui/components/table/TableCell';

class TableRow extends React.Component {
  static propTypes = {
    row: PropTypes.object,
    columns: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string,
        name: PropTypes.string,
      })
    ),
    actions: PropTypes.arrayOf(
      PropTypes.shape({
        icon: PropTypes.string,
        onClick: PropTypes.func,
      })
    ),
  };

  renderAction() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'actions' does not exist on type 'Readonl... Remove this comment to see the full error message
    if (this.props.actions) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'row' does not exist on type 'Readonly<{}... Remove this comment to see the full error message
      return <ActionCell row={this.props.row} actions={this.props.actions} />;
    }
  }

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'columns' does not exist on type 'Readonl... Remove this comment to see the full error message
    const tooltips = this.props.columns
      .filter((column: $TSFixMe) => column.type === 'tooltip')
      .reduce((obj: $TSFixMe, column: $TSFixMe) => {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'row' does not exist on type 'Readonly<{}... Remove this comment to see the full error message
        obj[column.on] = get(this.props.row, column.key);
        return obj;
      }, {});
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'columns' does not exist on type 'Readonl... Remove this comment to see the full error message
    const columns = this.props.columns.filter((column) => column.type !== 'tooltip');
    return (
      <tr>
        {columns.map((column: $TSFixMe) => (
          <TableCell
            key={column.key}
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'row' does not exist on type 'Readonly<{}... Remove this comment to see the full error message
            field={get(this.props.row, column.key)}
            column={column}
            tooltip={tooltips[column.key]}
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'row' does not exist on type 'Readonly<{}... Remove this comment to see the full error message
            row={this.props.row}
          />
        ))}
        {this.renderAction()}
      </tr>
    );
  }
}

export default TableRow;
